import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { authAuthRoutes } from './auth.routes';
import { AUTH_CONFIG, AuthConfig } from './auth.config';

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(authAuthRoutes)],
})
export class AuthModule {
  static forRoot(config: AuthConfig) {
    return {
      ngModule: AuthModule,
      providers: [{ provide: AUTH_CONFIG, useValue: config }],
    };
  }
}
